import { render, staticRenderFns } from "./BlogRead.vue?vue&type=template&id=19d519e9&"
import script from "./BlogRead.vue?vue&type=script&lang=js&"
export * from "./BlogRead.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports